import { X } from 'lucide-react';
import { Button } from './button';

export const RightPanel = ({ open, onClose, title, subtitle, chain, children, actions, width = 'w-[480px]', testId }) => {
  if (!open) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black/20 backdrop-blur-[2px] z-40" onClick={onClose} data-testid="right-panel-backdrop" />
      <div
        className={`fixed top-0 right-0 h-full ${width} bg-white border-l border-neutral-200 z-50 flex flex-col shadow-xl animate-in slide-in-from-right duration-200`}
        data-testid={testId || 'right-panel'}
      >
        {/* Header */}
        <div className="flex items-start justify-between p-6 border-b border-neutral-200">
          <div className="flex-1 min-w-0">
            <h2 className="text-base font-bold text-black truncate" data-testid="right-panel-title">{title}</h2>
            {subtitle && <div className="text-xs text-neutral-500 mt-1">{subtitle}</div>}
          </div>
          <button onClick={onClose} className="ml-4 h-8 w-8 rounded-lg border border-neutral-200 flex items-center justify-center hover:bg-neutral-50 transition-colors shrink-0" data-testid="right-panel-close">
            <X className="h-4 w-4 text-neutral-500" strokeWidth={1.5} />
          </button>
        </div>

        {/* Chain Visual */}
        {chain && (
          <div className="px-6 py-4 border-b border-neutral-200 bg-neutral-50/50">
            {chain}
          </div>
        )}

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6">
          {children}
        </div>

        {/* Actions */}
        {actions && (
          <div className="p-6 border-t border-neutral-200 flex items-center gap-3">
            {actions}
          </div>
        )}
      </div>
    </>
  );
};
